"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const nav_1 = require("components/cosmos/nav");
const modal_1 = require("components/cosmos/v2/modal");
const translate_1 = require("components/translate");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
require("modules/app/components/fixExternalLeak.scss");
const constants_1 = require("modules/player/constants");
const deviceTab_1 = __importDefault(require("./deviceTab"));
const filesTab_1 = __importDefault(require("./filesTab"));
const types_1 = require("./types");
const playerBackofficeModal_module_scss_1 = __importDefault(require("./playerBackofficeModal.module.scss"));
const PlayerBackofficeModal = ({ selectedMedia, isOpen, onClose, libraryActions, PlayerBackofficeStore, t, tabs: extraTabs, addLibraryItemButton }) => {
    const [currentProductTab, otherProductTab] = extraTabs || [];
    const initialTab = types_1.Tab.Files;
    const [tabId, setTabId] = (0, react_1.useState)(initialTab);
    const handleClose = () => {
        PlayerBackofficeStore.replaceMediaId = null;
        PlayerBackofficeStore.deselectMedia();
        onClose();
        setTabId(initialTab);
    };
    const tabs = (0, react_1.useMemo)(() => [
        {
            id: types_1.Tab.Files,
            name: t('player_backoffice.general.backoffice')
        },
        {
            id: types_1.Tab.ThisProduct,
            name: t('files.library.files_of_product')
        },
        {
            id: types_1.Tab.OtherProduct,
            name: t('files.library.files_of_other_products')
        },
        {
            id: types_1.Tab.Device,
            name: t('player_backoffice.general.insert_from_device')
        }
    ], [t]);
    const renderedTab = {
        [types_1.Tab.Files]: (0, jsx_runtime_1.jsx)(filesTab_1.default, {}),
        [types_1.Tab.Device]: (0, jsx_runtime_1.jsx)(deviceTab_1.default, { onClose: handleClose }),
        [types_1.Tab.ThisProduct]: currentProductTab,
        [types_1.Tab.OtherProduct]: otherProductTab
    }[tabId];
    const handleAddMediaFromLibrary = () => {
        const media = {
            id: selectedMedia.upload_key,
            name: selectedMedia.name,
            status: constants_1.PLAYER_STATUS.FINISHED,
            creationDate: selectedMedia.create_date,
            size: selectedMedia.size,
            playerMedia: {
                playerKey: selectedMedia.code,
                status: constants_1.PLAYER_STATUS.THUMBNAIL_READY,
                type: selectedMedia.type,
                duration: selectedMedia.duration
            }
        };
        if (PlayerBackofficeStore.replaceMediaId) {
            libraryActions.deleteUpload(PlayerBackofficeStore.replaceMediaId);
        }
        libraryActions.setUpload(media);
        handleClose();
    };
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { show: isOpen, onClose: handleClose, className: `${playerBackofficeModal_module_scss_1.default.container} cc-overlay-modal`, children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("h2", { children: t('player_backoffice.general.files') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: `${playerBackofficeModal_module_scss_1.default.modalBody} library__modal`, children: [(0, jsx_runtime_1.jsx)(nav_1.Nav, { className: "_mb-6", children: tabs.map((tab) => ((0, jsx_runtime_1.jsx)("button", { onClick: () => setTabId(tab.id), className: "_p-0 _bg-transparent _border-0", children: (0, jsx_runtime_1.jsx)(nav_1.Nav.Item, { active: tab.id === tabId, children: tab.name }) }, tab.id))) }), (0, jsx_runtime_1.jsx)("section", { className: playerBackofficeModal_module_scss_1.default.tabContent, children: renderedTab })] }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _justify-content-lg-end _gap-3", children: [tabId === types_1.Tab.Files && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(button_1.default, { onClick: handleClose, variation: "tertiary", children: t('general.cancel') }), (0, jsx_runtime_1.jsx)(button_1.default, { onClick: handleAddMediaFromLibrary, variation: "primary", disabled: Object.keys(selectedMedia).length === 0, children: t('player_backoffice.file_explorer.media_add') })] })), (tabId === types_1.Tab.ThisProduct || tabId === types_1.Tab.OtherProduct) &&
                        addLibraryItemButton] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    selectedMedia: stores.PlayerBackofficeStore.selectedMedia,
    PlayerBackofficeStore: stores.PlayerBackofficeStore
})))(PlayerBackofficeModal);
